var _path, _path2, _g, _rect, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMatcha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6204 19.1204C14.8182 22.9225 8.65375 22.9225 4.85161 19.1204C1.04946 15.3182 1.04946 9.15375 4.85161 5.35161C8.65375 1.54946 14.8182 1.54946 18.6204 5.35161C22.4225 9.15375 22.4225 15.3182 18.6204 19.1204Z",
    fill: "#D8E3C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1183 17.6183C14.1458 20.5909 9.32625 20.5909 6.35366 17.6183C3.38108 14.6458 3.38108 9.82625 6.35366 6.85366C9.32625 3.88108 14.1458 3.88108 17.1183 6.85366C20.0909 9.82625 20.0909 14.6458 17.1183 17.6183Z",
    fill: "#EDFFF1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_i_3_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6234 16.1234C13.4581 18.2886 9.94754 18.2886 7.78229 16.1234C5.61704 13.9581 5.61704 10.4475 7.78229 8.28229C9.94754 6.11704 13.4581 6.11704 15.6234 8.28229C17.7886 10.4475 17.7886 13.9581 15.6234 16.1234Z",
    fill: "#EDFFF1"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.4952,
    y: 16.7421,
    width: 4.95651,
    height: 3.18633,
    rx: 1.38612,
    transform: "rotate(45 18.4952 16.7421)",
    fill: "#D8E3C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.278 6.86028C10.5952 7.69551 10.4285 8.84572 9.29399 10.1123C8.15947 11.379 7.03448 11.6708 6.16949 11.4471C5.8523 10.6119 6.01894 9.46169 7.15346 8.19507C8.28798 6.92844 9.41297 6.63663 10.278 6.86028Z",
    fill: "#A3C724"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0176 3.29146C12.9806 4.07659 11.6224 6.65002 11.6224 6.65002C11.6224 6.65002 15.4362 8.78377 18.9153 7.75452C21.6626 6.94176 23.4848 3.21438 23.4848 3.21438C20.0036 4.59142 16.8728 1.12966 14.0176 3.29146Z",
    fill: "#A3C724"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13245 12.4944C6.69183 12.5345 7.30269 12.9334 7.72407 13.9141C8.14545 14.8947 8.01432 15.6124 7.65839 16.0458C7.09901 16.0057 6.48815 15.6069 6.06677 14.6262C5.64539 13.6455 5.77652 12.9278 6.13245 12.4944Z",
    fill: "#A3C724"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52576 16.8471C8.88886 16.4197 9.57169 16.1629 10.6117 16.4029C11.6518 16.6429 12.153 17.173 12.2921 17.7163C11.929 18.1437 11.2462 18.4005 10.2061 18.1605C9.16607 17.9205 8.66484 17.3904 8.52576 16.8471Z",
    fill: "#A3C724"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6473 17.451C13.5604 16.9882 13.7538 16.407 14.4601 15.8554C15.1665 15.3038 15.7772 15.257 16.2051 15.4535C16.292 15.9163 16.0986 16.4975 15.3923 17.049C14.686 17.6006 14.0752 17.6474 13.6473 17.451Z",
    fill: "#A3C724"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3_17",
    x: 6.15836,
    y: 6.65836,
    width: 11.0889,
    height: 11.782,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.693058
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.346529
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.132028 0 0 0 0 0.404167 0 0 0 0 0.0639931 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3_17"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatcha);
export default __webpack_public_path__ + "static/media/matcha.45d92c302a78ac44d6b3755a5bd21f33.svg";
export { ForwardRef as ReactComponent };